import { takeEvery } from 'redux-saga/effects'
import store from '../store'
import { LANGUAGE_CHANGE } from '../constants'
import i18n from '../utils/i18n'

/**
 * lang.saga of employer side is copied to develop separately with user side
 * if this original is updated, let check and done the same things with employer side
 */

/**
 * @author Pragya Gupta
 */

function* changeLanguage() {
  try {
    const selectedLang = store.getState().language.lang
    i18n.changeLanguage(selectedLang)
  } catch (error) {
    // console.warn(error)
  }
}

export function* watchChangeLanguageSaga() {
  yield takeEvery(LANGUAGE_CHANGE, changeLanguage)
}
